export default __webpack_public_path__ + "static/media/ic-delete.69a2af48.svg";